// Mock data for Sun Projects Landing Page - Expert Positioning

export const companyInfo = {
  name: "Sunprojects GmbH",
  contact: {
    person: "Michael Kaufmann",
    position: "Geschäftsführer",
    phone: "+49 2235 9762339",
    email: "info@sunprojects-gmbh.de",
    address: {
      label: "Adresse",
      street: "Bornbachstraße 80",
      zip: "35789",
      city: "Weilmünster"
    },
    legal: "Registergericht Köln · HRB 93908"
  },
  logo: "https://customer-assets.emergentagent.com/job_15903c68-58fe-4e19-882e-3757900d536c/artifacts/ona475y8_IMG_0023.jpeg",
  heroImage: "https://customer-assets.emergentagent.com/job_15903c68-58fe-4e19-882e-3757900d536c/artifacts/aovq0ae6_E3126324-4DFA-4799-89CA-6D6AF919F535.png"
};

export const trustIndicators = [
  {
    value: "20+",
    title: "Jahre Branchenerfahrung",
    description: "Über 20 Jahre Erfahrung in der Photovoltaikbranche – von der Produktentwicklung bis zur Anlagenrealisierung.",
    icon: "award"
  },
  {
    value: "10 MW+",
    title: "Installierte Photovoltaikleistung",
    description: "Planung und Umsetzung zahlreicher Photovoltaikprojekte – von Einfamilienhäusern bis zu Großanlagen.",
    icon: "zap"
  },
  {
    value: "INT",
    title: "Internationale Projekterfahrung",
    description: "Mehrjährige internationale Erfahrung in der Planung von Solaranlagen, unter anderem in Belgien.",
    icon: "globe"
  },
  {
    value: "360°",
    title: "Ganzheitliche Energiesysteme",
    description: "Integration von Photovoltaik, Batteriespeicher, Ladeinfrastruktur und Wärmepumpe zu einem Gesamtsystem.",
    icon: "layers"
  }
];

export const whyPhotovoltaics = [
  {
    title: "Steigende Strompreise",
    description: "Die Energiekosten steigen kontinuierlich. Mit einer eigenen PV-Anlage schützen Sie sich vor zukünftigen Preiserhöhungen.",
    icon: "trending-up",
    stat: "+47%",
    statLabel: "Strompreisanstieg seit 2019"
  },
  {
    title: "Energieunabhängigkeit",
    description: "Produzieren Sie Ihren eigenen Strom und reduzieren Sie Ihre Abhängigkeit vom Energieversorger deutlich.",
    icon: "home",
    stat: "bis 85%",
    statLabel: "Eigenversorgung möglich"
  },
  {
    title: "Intelligente Speicherung",
    description: "Moderne Batteriespeicher ermöglichen hohe Eigenverbrauchsquoten – auch abends und nachts.",
    icon: "battery-charging",
    stat: "24/7",
    statLabel: "Eigener Strom verfügbar"
  },
  {
    title: "Langfristige Wirtschaftlichkeit",
    description: "Eine PV-Anlage amortisiert sich heute schneller als je zuvor und liefert über Jahrzehnte kostenlosen Strom.",
    icon: "piggy-bank",
    stat: "8-10 J.",
    statLabel: "Amortisationszeit"
  }
];

export const systemComponents = [
  {
    title: "Photovoltaik-Module",
    description: "Hocheffiziente Solarmodule wandeln Sonnenlicht in elektrische Energie um – das Herzstück jedes Energiesystems.",
    icon: "sun"
  },
  {
    title: "Batteriespeicher",
    description: "Speichern Sie überschüssigen Solarstrom für die Nutzung am Abend und in der Nacht.",
    icon: "battery-charging"
  },
  {
    title: "Wallbox",
    description: "Laden Sie Ihr Elektrofahrzeug mit selbst erzeugtem Solarstrom – günstig und CO₂-neutral.",
    icon: "car"
  },
  {
    title: "Wärmepumpe",
    description: "Nutzen Sie Ihren Solarstrom zum Heizen und Kühlen – für maximale Energieeffizienz.",
    icon: "thermometer"
  },
  {
    title: "Energiemanagement",
    description: "Intelligente Steuerung optimiert den Energiefluss und maximiert Ihren Eigenverbrauch.",
    icon: "cpu"
  },
  {
    title: "Versorgungssicherheit",
    description: "Bei längeren Stromausfällen kann Ihr Speicher über einen externen Generator nachgeladen werden – für zusätzliche Sicherheit in außergewöhnlichen Situationen.",
    icon: "shield-check"
  }
];

export const whySunprojects = [
  {
    title: "Individuelle Planung statt Standardpakete",
    description: "Jede Photovoltaikanlage wird individuell für Ihr Gebäude, Ihren Energieverbrauch und Ihre zukünftigen Bedürfnisse geplant.",
    icon: "pencil-ruler"
  },
  {
    title: "Technische Systemkompetenz",
    description: "Tiefgreifendes Verständnis der Photovoltaik-Technologie und komplexer Energiesysteme durch langjährige Branchenerfahrung.",
    icon: "settings"
  },
  {
    title: "Ganzheitliche Energiekonzepte",
    description: "Integration von Solarstrom, Speicher, Elektromobilität und Wärmeerzeugung zu einem intelligenten Gesamtsystem.",
    icon: "git-merge"
  },
  {
    title: "Persönliche Betreuung",
    description: "Direkte Beratung und Projektbegleitung vom Erstkontakt über die Planung bis zur Inbetriebnahme – und darüber hinaus.",
    icon: "user"
  }
];

export const referenceProjects = [
  {
    id: 1,
    title: "Einfamilienhaus in Hessen",
    location: "Weilmünster",
    image: "https://customer-assets.emergentagent.com/job_428d3a15-b5a9-42b0-abcc-8c2c2ad90276/artifacts/tvzlq6m7_IMG_3926.jpeg",
    pvSize: "11.2 kWp",
    batterySize: "10 kWh",
    autonomyRate: "78%",
    description: "Komplettes Energiesystem mit PV-Anlage, Speicher und Wallbox für eine vierköpfige Familie."
  },
  {
    id: 2,
    title: "Neubau mit Wärmepumpe",
    location: "Köln-Süd",
    image: "https://customer-assets.emergentagent.com/job_428d3a15-b5a9-42b0-abcc-8c2c2ad90276/artifacts/pjz9i1r7_IMG_4715.jpeg",
    pvSize: "14.5 kWp",
    batterySize: "15 kWh",
    autonomyRate: "85%",
    description: "Ganzheitliches Energiekonzept mit PV, Speicher, Wärmepumpe und intelligentem Energiemanagement."
  },
  {
    id: 3,
    title: "Bestandssanierung",
    location: "Erftstadt",
    image: "https://customer-assets.emergentagent.com/job_428d3a15-b5a9-42b0-abcc-8c2c2ad90276/artifacts/qgx1legn_IMG_0541.jpeg",
    pvSize: "9.8 kWp",
    batterySize: "8 kWh",
    autonomyRate: "72%",
    description: "Nachrüstung auf bestehendem Satteldach mit optimaler Ausnutzung der verfügbaren Dachfläche."
  }
];

export const founderExpertise = {
  name: "Michael Kaufmann",
  position: "Gründer & Geschäftsführer",
  headline: "20 Jahre Erfahrung in der Photovoltaikbranche",
  intro: "Photovoltaik ist kein Produkt – sondern ein Energiesystem. Mit dieser Überzeugung und über 20 Jahren Branchenerfahrung plane und realisiere ich hochwertige Energiesysteme, die technisch durchdacht und wirtschaftlich sinnvoll sind.",
  qualifications: {
    title: "Technische Qualifikation",
    items: [
      "Ausgebildeter Elektriker",
      "Staatlich geprüfter Elektrotechniker",
      "Staatlich geprüfter Wirtschaftstechniker",
      "Zertifizierter Kälte- und Klimatechniker"
    ]
  },
  industryExperience: {
    title: "Erfahrung in der Photovoltaikindustrie",
    items: [
      "Produktentwicklung von Photovoltaikmodulen",
      "Qualitätsmanagement für PV-Module",
      "Reklamationsmanagement für Photovoltaikanlagen",
      "Produktmanagement für Wechselrichter und DC-Komponenten"
    ]
  },
  internationalExperience: {
    title: "Internationale Erfahrung",
    description: "Mehrjährige Tätigkeit in Belgien im Bereich Planung und Entwicklung von Groß-Solaranlagen. Mitwirkung an internationalen Photovoltaikprojekten und Erfahrung mit Freiflächenanlagen im MW-Bereich."
  },
  projectExperience: {
    title: "Projektumsetzung",
    items: [
      "Über 10 MW installierte Photovoltaikleistung",
      "Erfahrung mit Freiflächenanlagen und Großanlagen",
      "Spezialisierung auf Residential-Anlagen",
      "Integration von Speichern, Wärmepumpen und Ladeinfrastruktur"
    ]
  }
};

export const processSteps = [
  {
    step: 1,
    title: "Beratung",
    description: "Kostenlose Erstberatung vor Ort. Wir analysieren Ihr Dach, erfassen Ihren Stromverbrauch und besprechen Ihre Ziele und Wünsche.",
    icon: "message-circle"
  },
  {
    step: 2,
    title: "Planung",
    description: "Individuelle Anlagenplanung mit detaillierter Wirtschaftlichkeitsberechnung, 3D-Visualisierung und technischer Dokumentation.",
    icon: "file-text"
  },
  {
    step: 3,
    title: "Installation",
    description: "Professionelle Montage durch erfahrene Fachkräfte. Saubere Ausführung, termingerechte Umsetzung und höchste Qualitätsstandards.",
    icon: "wrench"
  },
  {
    step: 4,
    title: "Inbetriebnahme",
    description: "Netzanmeldung, Einweisung in Ihr System und Übergabe. Wir stehen Ihnen auch nach der Installation beratend zur Seite.",
    icon: "zap"
  }
];

export const faqItems = [
  {
    question: "Lohnt sich eine Photovoltaikanlage noch?",
    answer: "Ja, mehr denn je. Mit Strompreisen von über 35 Cent/kWh und deutlich gesunkenen Modulpreisen amortisiert sich eine PV-Anlage heute schneller als je zuvor – typischerweise nach 8-10 Jahren. Danach produzieren Sie für weitere 15-20 Jahre nahezu kostenlosen Strom."
  },
  {
    question: "Was kostet eine komplette Anlage?",
    answer: "Die Kosten hängen von der Anlagengröße und Ausstattung ab. Eine typische Anlage für ein Einfamilienhaus (10 kWp mit Speicher) liegt zwischen 18.000 und 25.000 Euro. Wir erstellen Ihnen ein individuelles Angebot mit transparenter Kostenaufstellung."
  },
  {
    question: "Wie lange dauert die Installation?",
    answer: "Die reine Montage dauert in der Regel 2-3 Tage. Von der Auftragserteilung bis zur Inbetriebnahme vergehen typischerweise 4-8 Wochen – abhängig von der Verfügbarkeit der Komponenten und der Bearbeitungszeit beim Netzbetreiber."
  },
  {
    question: "Wie lange hält ein Batteriespeicher?",
    answer: "Moderne Lithium-Ionen-Speicher sind für mindestens 10.000 Ladezyklen ausgelegt, was einer Lebensdauer von 15-20 Jahren entspricht. Die meisten Hersteller geben 10 Jahre Garantie auf ihre Speichersysteme."
  },
  {
    question: "Was passiert bei einem Stromausfall?",
    answer: "Mit einem Batteriespeicher und Notstromfunktion können Sie bei einem Netzausfall weiterhin wichtige Verbraucher mit Strom versorgen. Wir beraten Sie gerne zu den verschiedenen Notstrom-Optionen und finden die passende Lösung."
  },
  {
    question: "Welche Förderungen gibt es?",
    answer: "Aktuell entfällt die Mehrwertsteuer auf PV-Anlagen und Speicher. Zusätzlich gibt es in vielen Bundesländern und Kommunen regionale Förderprogramme. Wir informieren Sie im Beratungsgespräch über die aktuellen Möglichkeiten."
  }
];

export const roofTypes = [
  "Satteldach",
  "Flachdach",
  "Pultdach",
  "Walmdach",
  "Carport/Garage",
  "Sonstiges"
];

export const roofOrientations = [
  { value: "south", label: "Süd", factor: 1.0 },
  { value: "east-west", label: "Ost-West", factor: 0.85 },
  { value: "east", label: "Ost", factor: 0.8 },
  { value: "west", label: "West", factor: 0.8 }
];

// Founder info for FounderSection
export const founderInfo = {
  name: "Michael Kaufmann",
  position: "Gründer & Geschäftsführer",
  experience: "20+ Jahre",
  qualities: [
    "Ausgebildeter Elektriker & Elektrotechniker",
    "Zertifizierter Kälte- und Klimatechniker",
    "Erfahrung in Produktentwicklung & Qualitätsmanagement",
    "Internationale Projekterfahrung (>10 MW installiert)",
    "Persönliche Betreuung vom Erstkontakt bis zur Inbetriebnahme"
  ]
};

// Customer problems for ProblemSection
export const customerProblems = [
  {
    title: "Steigende Stromkosten",
    description: "Die Energiepreise kennen nur eine Richtung: nach oben. Jede Jahresabrechnung bringt neue Überraschungen.",
    icon: "trending-up"
  },
  {
    title: "Abhängigkeit vom Netz",
    description: "Als Stromkunde sind Sie den Preisentscheidungen Ihres Versorgers vollständig ausgeliefert.",
    icon: "link"
  },
  {
    title: "Unübersichtlicher Markt",
    description: "Viele Anbieter, unterschiedliche Qualitäten – wem kann man bei dieser wichtigen Investition vertrauen?",
    icon: "help-circle"
  },
  {
    title: "Komplexe Wirtschaftlichkeit",
    description: "Lohnt sich eine PV-Anlage wirklich? Und wenn ja, welche Größe ist optimal für Ihre Situation?",
    icon: "calculator"
  }
];

